export function isValidAddress(addressObject) {
    return Boolean(
        typeof addressObject === 'object' &&
        addressObject != null &&
        addressObject.formattedAddress &&
        addressObject.suburb &&
        addressObject.state === 'NSW'
    );
}
